<template>
    <div class="common-accordion">
        <div
            class="common-accordion__item"
            v-for="(item, index) in items"
            v-bind:key="item.id"
            v-bind:class="{ _expanded: openIndex === index }"
        >
            <button
                class="common-accordion__item-header"
                v-on:click="toggle(index)"
            >
                <span class="common-accordion__item-header-arrow">
                    <icon name="triangle" />
                </span>
                <span class="common-accordion__item-header-title">
                    {{ item.title }}
                </span>
            </button>

            <transition name="common-accordion">
                <div
                    class="common-accordion__item-content"
                    v-html="item.text"
                    v-if="openIndex === index"
                />
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'common-accordion',
    props: {
        items: {
            type: Array,
            required: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            openIndex: 0,
        };
    },
    methods: {
        toggle(index) {
            if (this.multiple) {
                // TODO
            } else {
                this.openIndex = this.openIndex === index ? null : index;
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~theme';

.common-accordion {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 32px;

    &__item {
        border-bottom: 1px solid @color-gray-light-secondary;

        &._expanded {
            border-color: @color-primary;
        }

        &-header {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
            padding-bottom: 16px;

            cursor: pointer;
            &-arrow {
                flex: 0 0 auto;
                margin-right: 24px;

                color: @color-gray-main;
                font-size: 2.4rem;

                transform: translateY(2px) rotate(90deg);
            }
            ._expanded > & > &-arrow {
                color: @color-gray-darkest;

                transform: translateY(2px) rotate(180deg);
            }
            &-title {
                .typography-medium();

                text-align: left;
                flex: 0 1 auto;
            }
            ._expanded > & > &-title {
                color: @color-primary;
            }
        }
        &-content {
            .typography-small();

            padding-bottom: 16px;
            /deep/ p {
                margin: 0;
            }
        }
    }

    @media @media-md-down {
        &__item {
            &-header {
                &-title {
                    .typography-heading();

                }
            }
            &-content {
                .typography-heading();
            }
        }
    }
}

.common-accordion-enter-active,
.common-accordion-leave-active {
    transition: all 0.3s ease;
}

.common-accordion-enter,
.common-accordion-leave-to {
    opacity: 0;
    max-height: 0;
    padding: 0 20px;
}
</style>
